import { useContext } from 'react';
import type { IYwuAppContextValues } from './ywu-app-context';
import { ywuAppContext } from './ywu-app-context';

export function useYwuApp(): IYwuAppContextValues {
    const context = useContext(ywuAppContext);
    if (context == null) throw new Error('useYwuApp must be used within the <YwuAppProvider>');

    return context;
}
